export default __webpack_public_path__ + "static/media/cams.91d4c909.svg";